module.exports = "<div class=\"label1\">\n    <button class=\"btnCenter btn btn-warning btn-md\" (click)=\"back()\">Wake Up to Cloud</button>\n</div>"